export default (state, action) => {
  switch (action.type) {
    case "SELECT_PROJECT":
      return {
        ...state,
        currentProject: action.data
      }
    default:
      return state;
  }
};
